import { warrantySDKLoadSuccess } from '../slice/warranty.slice';

export const warrantySDKLoadUpdatedEvent = warrantySDKLoadSuccess.fulfilled;
